import { createSlice } from "@reduxjs/toolkit";
import { fetchCategories, fetchProducts } from "./operations";
import {
  handleCategoriesFulfilled,
  handlePending,
  handleProductsFulfilled,
  handleReject,
} from "./actions";

const initialState = {
  products: [],
  categories: [],
  isLoading: false,
  error: null,
};

const products = createSlice({
  name: "products",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, handlePending)
      .addCase(fetchProducts.fulfilled, handleProductsFulfilled)
      .addCase(fetchProducts.rejected, handleReject)
      .addCase(fetchCategories.pending, handlePending)
      .addCase(fetchCategories.fulfilled, handleCategoriesFulfilled)
      .addCase(fetchCategories.rejected, handleReject);
  },
});

export const productsReducer = products.reducer;
